<script setup lang="ts">
import { authClient } from '~/lib/auth-client'
import { ROUTES } from '~/utils/constants'
const { data: session } = await authClient.useSession(useFetch)

const handleLogout = async () => {
  await authClient.signOut()
  navigateTo(ROUTES.HOME)
}

const navItems = [
  { label: 'Features', to: '#features' },
  { label: 'Pricing', to: ROUTES.PRICING },
  { label: 'FAQ', to: ROUTES.FAQ },
]
</script>

<template>
  <div class="min-h-screen flex flex-col bg-white dark:bg-gray-900">
    <!-- Header -->
    <header
      class="border-b border-gray-200 dark:border-gray-800 sticky top-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md"
    >
      <UContainer class="flex justify-between items-center h-16">
        <Logo size="md" />

        <UNavigationMenu :items="navItems" class="hidden md:flex" />

        <div class="flex items-center gap-2">
          <template v-if="session">
            <UButton :to="ROUTES.DASHBOARD" variant="ghost" color="neutral">Dashboard</UButton>
            <UButton @click="handleLogout" color="primary">Sign out</UButton>
          </template>
          <template v-else>
            <UButton
              :to="ROUTES.LOGIN"
              variant="ghost"
              :color="'gray' as any"
              class="text-gray-700 dark:text-gray-200"
              >Log in</UButton
            >
            <UButton :to="ROUTES.SIGNUP" color="primary">Get Started</UButton>
          </template>
          <ClientOnly>
            <UColorModeButton />
          </ClientOnly>
        </div>
      </UContainer>
    </header>

    <!-- Main Content -->
    <main class="grow">
      <slot />
    </main>

    <!-- Footer -->
    <footer class="border-t border-gray-200 dark:border-gray-800 py-8">
      <UContainer class="flex flex-col md:flex-row justify-between items-center gap-4">
        <p class="text-sm text-gray-500">
          © {{ new Date().getFullYear() }} TCF Canada. All rights reserved.
        </p>
        <div class="flex gap-4">
          <UButton
            icon="i-simple-icons-twitter"
            variant="ghost"
            :color="'gray' as any"
            to="#"
            target="_blank"
          />
          <UButton
            icon="i-simple-icons-github"
            variant="ghost"
            :color="'gray' as any"
            to="#"
            target="_blank"
          />
        </div>
      </UContainer>
    </footer>
  </div>
</template>
